// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-tutorials-js": () => import("./../../../src/components/tutorials.js" /* webpackChunkName: "component---src-components-tutorials-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-gallery-index-js": () => import("./../../../src/pages/gallery/index.js" /* webpackChunkName: "component---src-pages-gallery-index-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-privacy-js": () => import("./../../../src/pages/privacy.js" /* webpackChunkName: "component---src-pages-privacy-js" */),
  "component---src-pages-tutorials-index-js": () => import("./../../../src/pages/tutorials/index.js" /* webpackChunkName: "component---src-pages-tutorials-index-js" */)
}

